import { render, staticRenderFns } from "./STextarea.vue?vue&type=template&id=55926c93&scoped=true&"
import script from "./STextarea.vue?vue&type=script&lang=js&"
export * from "./STextarea.vue?vue&type=script&lang=js&"
import style0 from "./STextarea.vue?vue&type=style&index=0&id=55926c93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55926c93",
  null
  
)

export default component.exports